import React, { useState, useEffect } from 'react';
import './App.css';
import Dashboard from './components/Dashboard';
import MapView from './components/MapView';
import Login from './components/Login';

function App() {
  const [activeTab, setActiveTab] = useState('mapa');
  const [user, setUser] = useState(null);
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  }, [darkMode]);

  const handleLogin = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    setUser(null);
    setActiveTab('mapa');
  };

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  if (!user) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <div className="App">
      <header className="app-header">
        <div className="header-content">
          <img 
            src={darkMode ? "/logoTerranet2.png" : "/logoTerranet3.png"} 
            alt="Terranet Logo" 
            style={{ height: '40px', transition: 'all 0.3s ease' }}
          />
          <div className="header-text">
            <h1>GIS</h1>
            <p>Sistema de Gestión de Red de Fibra Óptica</p>
          </div>
        </div>

        <div className="header-controls">
          <button
            className="theme-toggle"
            onClick={toggleDarkMode}
            title={darkMode ? 'Modo Claro' : 'Modo Oscuro'}
          >
            {darkMode ? '☀️' : '🌙'}
          </button>

          <div className="user-info">
            <span className="user-role">{user.role}</span>
            <span className="user-name">👤 {user.username}</span>
            <button className="logout-button" onClick={handleLogout}>
              🚪 Salir
            </button>
          </div>
        </div>
      </header>

      <nav className="app-nav">
        <button 
          className={activeTab === 'dashboard' ? 'active' : ''} 
          onClick={() => setActiveTab('dashboard')}
        >
          📊 Dashboard
        </button>
        <button 
          className={activeTab === 'mapa' ? 'active' : ''} 
          onClick={() => setActiveTab('mapa')}
        >
          🗺️ Mapa
        </button>
      </nav>

      <main className="app-content">
        {activeTab === 'dashboard' && <Dashboard />}
        {activeTab === 'mapa' && <MapView user={user} />}
      </main>
    </div>
  );
}

export default App;
